import { ThemeProvider } from "styled-components";
import { theme } from "./theme.config";

export const Theme = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);
